import {
  ModalManager,
  useModal,
} from "@circle-react/components/Layout/ModalManagerProvider";
import type { ComponentPropsWithoutRef } from "react";

import { useIsCircleV4FeatureEnabled } from "@/react/hooks/useIsCircleV4FeatureEnabled";

import { ReportModalComponent } from "./ReportModalComponent";
import { ReportModalUIKitComponent } from "./ReportModalUIKitComponent";

type ReportModalUIKitComponentProps = ComponentPropsWithoutRef<
  typeof ReportModalUIKitComponent
>;

const ReportModalUIKit = ModalManager.create(
  (props: ReportModalUIKitComponentProps) => (
    <ReportModalUIKitComponent {...props} />
  ),
);

type ReportModalComponentProps = Omit<
  ComponentPropsWithoutRef<typeof ReportModalComponent>,
  "open" | "onOpenChange"
>;

const ReportModal = ModalManager.create((props: ReportModalComponentProps) => {
  const modal = useModal();

  return (
    <ReportModalComponent
      {...props}
      open={modal.visible}
      onOpenChange={open => {
        if (!open) {
          void modal.hide().then(() => modal.remove());
        }
      }}
    />
  );
});

export const useReportModal = () => {
  const isCircleV4 = useIsCircleV4FeatureEnabled("circle_v4_modals_enabled");
  const ModalComponent = isCircleV4 ? ReportModal : ReportModalUIKit;

  return useModal(ModalComponent);
};
